export * from './delete-template.component';
export * from './delete-template.component.module';